export function prefillNewsletterForm(field) {

    if (window.location.pathname !== '/newsletter') {
        return
    }

    const urlParams = new URLSearchParams(window.location.search)
    const emailParam = urlParams.get('email')

    if (!emailParam) {
        return field.default || ''
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(emailParam)) {
        return ''
    } else {
        return emailParam
    }
}
